// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BG8J","buttons":"styles_buttons__1kERF"};